<template>
  <div class="promotion-report-wrap">
    <div class="slide-wrap">
      <ul class="menu-list">
        <li
          v-for="item in menuList"
          :key="item.componentName"
          :class="['menu-item', curComponent === item.componentName ? 'cur' : '']"
          @click="changePlat(item.componentName)"
        >
          <svg-icon :iconClass="item.icon" className="menu-icon"></svg-icon> {{ item.menuText }}
        </li>
      </ul>
    </div>
    <div class="content-wrap">
      <component ref="curTableRef" v-bind:is="curComponent"></component>
    </div>
  </div>
</template>

<script>
import ToutiaoReport from "./promotionReport/tableIndex.vue";
import newToutiaoReport from "./promotionReport-ttV2/tableIndex.vue";
import KuaishouReport from "./promotionReport-kuaishou/tableIndex.vue";
import GoogleReport from "./promotionReport-google/tableIndex.vue";
import GdtReport from "./promotionReport-gdt/tableIndex.vue";
import TaskCenter from "./taskCenter/index.vue";
import SvgIcon from "@/components/SvgIcon.vue";
export default {
  name: "PromotionReports",
  components: {
    SvgIcon,
    ToutiaoReport,
    newToutiaoReport,
    KuaishouReport,
    GdtReport,
    TaskCenter,
    GoogleReport,
  },
  data() {
    return {
      curComponent: "ToutiaoReport",
      menuList: [
        {
          menuText: "今日头条",
          icon: "jrtt",
          componentName: "ToutiaoReport",
        },
        {
          menuText: "今日头条2.0",
          icon: "jrtt",
          componentName: "newToutiaoReport",
        },
        {
          menuText: "快手",
          icon: "kuaishou",
          componentName: "KuaishouReport",
        },
        {
          menuText: "Google",
          icon: "google",
          componentName: "GoogleReport",
        },
        {
          menuText: "广点通",
          icon: "gdt",
          componentName: "GdtReport",
        },
        {
          menuText: "任务中心",
          icon: "taskCenter",
          componentName: "TaskCenter",
        },
      ],
    };
  },
  watch: {
    $route: {
      handler(val) {
        if (val.query.key) {
          this.curComponent = val.query.key;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    changePlat(platType) {
      this.curComponent = platType;
    },
  },
};
</script>

<style lang="less" scoped>
.promotion-report-wrap {
  display: flex;
  height: calc(100vh - 50px);
  width: 100%;
  .slide-wrap {
    flex-shrink: 0;
    width: 183px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding-top: 16px;
    box-sizing: border-box;
    .menu-list {
      padding: 0px;
      margin: 0px;
      list-style: none;
      .menu-item {
        font-size: 15px;
        font-weight: bold;
        margin-bottom: 10px;
        color: rgba(0, 0, 0, 0.65);
        cursor: pointer;
        padding: 12px 20px;
        &.cur {
          color: rgba(24, 144, 255, 1);
          background-color: rgba(24, 144, 255, 0.1);
        }
        &:hover {
          background-color: rgba(24, 144, 255, 0.1);
        }
        .menu-icon {
          font-size: 16px;
          margin-right: 2px;
        }
      }
    }
  }
  .content-wrap {
    width: 100%;
    box-sizing: border-box;
    overflow: auto;
  }
}
</style>
